import React from 'react';
import classNames from 'classnames';

import { FaqContainer } from '@vp/digital-faq-lib';
import { FeatureGroupModel } from '@vp/digital-common-data-model-lib';

import MissingContentAlert from '../MissingContentAlert';

import './WebsitesFAQs.scss';

type FaqsProps = {
  content?: FeatureGroupModel;
  collapsed?: boolean;
  className?: string;
};

export default function WebsitesFAQs({
  content,
  collapsed = true,
  className,
}: FaqsProps): JSX.Element {
  if (!content) {
    return <MissingContentAlert />;
  }

  return (
    <FaqContainer
      content={content}
      titleSize="large"
      titleAlign={'left'}
      collapsed={collapsed}
      faqQuestionsBackground={'transparent'}
      className={classNames('wix-websites__new__faq__container', className)}
    />
  );
}
